import {Vue} from "vue-property-decorator";
import {FileEntity} from "@/plugins/uyap-plugin/store/entity/FileEntity";
import {OdemeTipiEnum} from "@/plugins/uyap-plugin/takip_ac/OdemeTipleri";
import {VakifbankHesapBilgileri} from "@/plugins/uyap-plugin/uyap/VakifbankHesapListesi";
import {TamamlanmayanDosyalarRow} from "@/plugins/uyap-plugin/uyap/TamamlanmayanDosyalar";
import {KullaniciBilgileriCevap} from "@/plugins/uyap-plugin/uyap/KullaniciBilgileri";
import {PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {AktifKimlik} from "@/utils/aktifKimlik";
import {KimlikRedSebebi} from "@/utils/eicraproBaglantisi";
import {BotBeklemeSebebi} from "@/utils/botBekleme";

export type VForm = Vue & {
    validate: () => boolean;
    resetValidation: () => boolean;
    reset: () => void;
}

export enum AppStatus {
    loading,
    error,
    update,
    electron,
    browser,
}


export interface ManifestResponse {
    files: ManifestResponseFileItem[];
}

export interface ManifestResponseFileItem {
    path: string,
    sha256: string
}

export interface AppState {
    uyapConnection: boolean,
    appStatus: AppStatus,
    manifestResponse: ManifestResponse,
    availableCardList: any[],
    devMode: boolean,
    eicraproDevMode: boolean,
    uyapAvukatBilgileri?: KullaniciBilgileriCevap,
    uyapAvukatBakiye?: string,
    uyapSorguBakiye?: string,
    selectedCardSerial?: string | null,
    uyapStatusMessage?: UyapStatusMessage | null,
    connectionHealthCheckInterval: number | null,
    healthCheckRetryCount: number,
    healthCheckMaxRetries: number,
    sonImzaProbe: { basarili: boolean, zaman: number } | null,
    oturumLimitiUyarisi: { zaman: number } | null,
    devreKesiciUyarisi: { zaman: number } | null,
    // Giriş sürüyor mu ve hangi aşamada. null = giriş yapılmıyor.
    // "Bağlı Değil" ile "Bağlı" arasındaki üçüncü durum: kullanıcı 5 sn'lik
    // imzalama adımında ekranın donduğunu değil, girişin ilerlediğini görmeli.
    uyapGirisAsamasi: UyapGirisAsamasi | null,
    // Açık UYAP oturumu hesaba ait değil ya da sunucu lisans/TCKN denetimi reddetti (423).
    // Engelleyici: bot duraklatılır, işlem yapılmaz.
    kimlikUyusmazligiUyarisi: KimlikUyusmazligiUyarisi | null,
    // --- Aktif kimlik (DEV-2603; ayrıntı utils/aktifKimlik.ts, store/aktifKimlik.ts) ---
    // Bot bu kimlikle çalışır. sessionStorage'daki ham setConfig anahtarları yalnız ÖNERİDİR.
    aktifKimlik: AktifKimlik | null,
    // Aktif kimliğin token'ı sunucuda reddedildi (401); yeni öneri gelene kadar bekler.
    kimlikTokenGecersiz: boolean,
    // Aktif kimlikten FARKLI, henüz uygulanmamış öneri (tek yuva; en yenisi kazanır).
    bekleyenKimlik: BekleyenKimlik | null,
    // Öneri lisans denetiminden geçemedi. aktif YOKSA durum 'tckn-eksik' olur; aktif varsa
    // yalnız bilgi şeridi (kimlikReddiBuro) gösterilir, aktif kimlik KORUNUR.
    kimlikRedSebebi: KimlikRedSebebi | null,
    kimlikReddiBuro: string | null,
    // Son işlenen önerinin parmak izi (bellekte; aynı öneri art arda gelirse sıfır istek).
    kimlikOneriParmakIzi: string | null,
    // Son lisans sorgusu hatasının / reddinin zamanı: sağlık tiki 15 sn dolmadan yeniden denemez.
    kimlikSorgusuHatasi: number | null,
    // 'Geç' basıldı, süren alt görevin bitmesi bekleniyor.
    gecisDurumu: 'bekliyor' | null,
    // UYAP oturumu ESKİ avukata ait: sonraki girişte oturum devralınmaz, zorla giriş yapılır.
    oturumYenilenmeli: boolean,
    // Botun insan gerektiren bekleme nedeni (null = bekleme yok) ve sonraki deneme zamanı.
    botBeklemeSebebi: BotBeklemeSebebi | null,
    botSonrakiDeneme: number | null,
    // Son kart sorgusunda e-İmza programı yanıt vermedi.
    imzaProgramiKapali: boolean,
    // Kimlik uyuşmazlığı botu duraklattıysa önceki player durumu (doğrulanınca otomatik devam).
    kimlikDuraklatmasi: { oncekiPlayer: PlayerDurum, zaman: number } | null
}

export type KimlikUyusmazligiSebebi = 'hesap' | 'kart' | 'lisans' | 'lisans-tckn';

export interface KimlikUyusmazligiUyarisi {
    zaman: number,
    sebep: KimlikUyusmazligiSebebi,
    // Sunucunun 423 mesajı (lisans sebeplerinde).
    mesaj?: string
}

export interface BekleyenKimlik {
    kimlik: AktifKimlik,
    // token: aynı büro/hesap yeni token; tenant: aynı hesap başka büro; tckn: başka hesap ('Geç' şart).
    sebep: 'token' | 'tenant' | 'tckn',
    zaman: number,
    // Kullanıcı şeridi gizledi (bekleyen yine uygulanabilir olabilir).
    yoksayildi: boolean
}

export type UyapGirisAsamasi = 'oturum-kontrol' | 'imza' | 'bilgiler';

export interface UyapStatusMessage {
    type: 'success' | 'error' | 'info';
    text: string;
    timestamp: number;
}

export interface ITenant {
    id: number,
    tenant_id: string,
    title: string,
    user_id: number,
    role: string
}

export interface TamamlanmayanDosya extends TamamlanmayanDosyalarRow {
    createByEicrapro: boolean,
    ttDownloading: boolean,
    eicraproData: {
        id: number | undefined,
        hash: string | undefined,
        dosya: any | undefined,
        uyap_dosya_id: string | undefined,
        dosya_esas_no: string | undefined,
        icra_dairesi: string | undefined,
        vekalet_id: number | undefined | null,
        vekalet: {
            data: string, //base64 data
            dosya: Blob,
            hash: string,
            mimeType: string,
            name: string
        } | null,
        tebligatGideri: {
            tutar: string,
            aciklama: string,
            enabled: boolean,
        },
        odemeTipi: OdemeTipiEnum,
        vakifbankHesapBilgileri: VakifbankHesapBilgileri,
        file: FileEntity | null,
        takip_talebi_id: number | undefined,
        dayanak: Array<TamamlanmayanDosyaFile>,
        status: 1 | 2 | undefined  // 1: tevzi, 2: açıldı
    }
}

interface TamamlanmayanDosyaFile extends FileEntity {
    data: string,
    dosya: Blob,
    mimeType: string
}
